import styled from 'styled-components';

const TestimonialsStyle = styled.div`
	&.testimonialsContainer {
		--slideParentContWidth: 100%;
		--slideContMarginBottom: var(--sp10x);
		--symbolSize: var(--sp3x);
		--symbolMarginBottom: var(--sp2x);
		--textMarginBottom: var(--sp3x);
		--infoMarginBottom: var(--sp6x);
		--buttonContWidth: 100%;
		--paginationItemSize: var(--sp2x);
		--paginationItemMarginH: var(--sp2-5x);
		--sectionColor1: var(--color1);
		--sectionColor2: var(--color2);

		&.darkContainer {
			--sectionColor1: var(--color2);
			--sectionColor2: var(--color1);
		}

		position: relative;
		max-width: unset;
		width: 100vw;
		left: 50%;
		padding: var(--sectionToSection) 0;
		background-color: var(--sectionColor1);
		color: var(--sectionColor2);
		transform: translate3d(-50%, 0, 0);

		.title {
			margin-bottom: var(--titleToText);
		}

		.slideParentCont {
			width: var(--slideParentContWidth);
			margin: 0 auto;
			display: flex;
			flex-direction: column;

			& > * {
				opacity: 0;
			}

			.slideContainer {
				max-width: 100%;
				overflow-y: auto;
				padding-bottom: calc(var(--slideContMarginBottom) / 2);
				margin-bottom: calc(var(--slideContMarginBottom) / -2);

				.slide {
					.slideInner {
						.slideSymbol {
							display: inline-block;
							font-size: var(--symbolSize);
							margin-bottom: var(--symbolMarginBottom);
						}

						.slideText {
							margin-bottom: var(--textMarginBottom);
						}

						.slideInfoCont {
							display: flex;
							flex-wrap: wrap;
							justify-content: space-between;

							.slideInfo {
								margin-bottom: var(--infoMarginBottom);
							}

							.slideButtonCont {
								width: var(--buttonContWidth);
								display: flex;
								justify-content: flex-end;

								.slideButton {
									white-space: nowrap;
									margin-bottom: calc(var(--slideContMarginBottom) / 2);

									& > div {
										border-color: var(--sectionColor2);
									}
								}
							}
						}
					}
				}
			}

			.pagination {
				position: relative;
				z-index: 2;
				margin: 0 calc(var(--paginationItemMarginH) / -2);

				.paginationItem {
					display: inline-block;
					width: var(--paginationItemSize);
					height: var(--paginationItemSize);
					border: 2px solid var(--sectionColor2);
					background-color: var(--sectionColor1);
					margin: 0 calc(var(--paginationItemMarginH) / 2);

					&.paginationItemActive {
						background-color: var(--sectionColor2);
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSizeS}) {
		.title {
			font-size: 52px;
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		&.testimonialsContainer {
			--slideContMarginBottom: var(--sp2x);
			--symbolSize: var(--sp3x);
			--symbolMarginBottom: var(--sp4x);
			--textMarginBottom: var(--sp3x);
			--infoMarginBottom: var(--sp1-5x);
			--buttonContWidth: 100%;
			--paginationItemSize: var(--sp2x);
			--paginationItemMarginH: var(--sp2-5x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) {
		&.testimonialsContainer {
			--slideContMarginBottom: var(--sp2x);
			--symbolSize: var(--sp3x);
			--symbolMarginBottom: var(--sp4x);
			--textMarginBottom: var(--sp3x);
			--infoMarginBottom: var(--sp1-5x);
			--buttonContWidth: auto;
			--paginationItemSize: var(--sp2x);
			--paginationItemMarginH: var(--sp2-5x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) {
		&.testimonialsContainer {
			--slideParentContWidth: 65vw;
			--slideContMarginBottom: var(--sp6x);
			--symbolSize: var(--sp4x);
			--symbolMarginBottom: var(--sp4x);
			--textMarginBottom: var(--sp4x);
			--infoMarginBottom: var(--sp3x);
			--buttonContWidth: auto;
			--paginationItemSize: var(--sp2x);
			--paginationItemMarginH: var(--sp2-5x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) {
		&.testimonialsContainer {
			--slideParentContWidth: 64.78vw;
			--slideContMarginBottom: var(--sp7x);
			--symbolSize: var(--sp4x);
			--symbolMarginBottom: var(--sp4x);
			--textMarginBottom: var(--sp4x);
			--infoMarginBottom: var(--sp3x);
			--buttonContWidth: auto;
			--paginationItemSize: var(--sp2x);
			--paginationItemMarginH: var(--sp2-5x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) {
		&.testimonialsContainer {
			--slideParentContWidth: 66.11vw;
			--slideContMarginBottom: var(--sp7x);
			--symbolSize: var(--sp4x);
			--symbolMarginBottom: var(--sp4x);
			--textMarginBottom: var(--sp5x);
			--infoMarginBottom: var(--sp3x);
			--buttonContWidth: auto;
			--paginationItemSize: var(--sp2x);
			--paginationItemMarginH: var(--sp2-5x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) {
		&.testimonialsContainer {
			--slideParentContWidth: 67.9vw;
			--slideContMarginBottom: var(--sp8x);
			--symbolSize: var(--sp5x);
			--symbolMarginBottom: var(--sp4x);
			--textMarginBottom: var(--sp8x);
			--infoMarginBottom: var(--sp4x);
			--buttonContWidth: auto;
			--paginationItemSize: var(--sp2x);
			--paginationItemMarginH: var(--sp2-5x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
		&.testimonialsContainer {
			--slideParentContWidth: 60vw;
			--slideContMarginBottom: var(--sp8x);
			--symbolSize: var(--sp6x);
			--symbolMarginBottom: var(--sp5x);
			--textMarginBottom: var(--sp9x);
			--infoMarginBottom: var(--sp5x);
			--buttonContWidth: auto;
			--paginationItemSize: var(--sp2-5x);
			--paginationItemMarginH: var(--sp3x);
		}
	}
`;

export default TestimonialsStyle;
